// extracted by mini-css-extract-plugin
export default {"BooleanListFeature":"wk_a bib_b"};